import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  showMessage(message: string, duration: number = 3000): void {
    this.snackBar.open(message, 'Close', {
      duration: duration,   // Duration for the snack bar to appear (in ms)
      horizontalPosition: 'right',  // Position of the snack bar (can be 'left', 'center', 'right')
      verticalPosition: 'bottom',  // Position of the snack bar (can be 'top', 'bottom')
    });
  }
}
